// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"780":"9fe2d3e3","801":"76f826ef"}[chunkId] + ".chunk.css";
};